/* tslint:disable */
/* eslint-disable */

export interface AbstractDraftState {
    type: "DraftStateWrapper" | "StrategyDraftStateWrapper";
}

export interface AcceptanceBriefResource extends Resource {
    briefId: string;
    company?: CompanyResource;
}

export interface Address extends AddressView {
}

export interface AddressView {
    administrativeAreaLevel1?: string;
    administrativeAreaLevel1Code?: string;
    administrativeAreaLevel2?: string;
    administrativeAreaLevel2Code?: string;
    administrativeAreaLevel3?: string;
    administrativeAreaLevel3Code?: string;
    administrativeAreaLevel4?: string;
    administrativeAreaLevel4Code?: string;
    city?: string;
    country?: string;
    countryCode?: string;
    formattedAddress?: string;
    loc?: Point;
    region?: string;
    street?: string;
    street2?: string;
    zipCode?: string;
}

export interface BriefCurrencyResource {
    currency: string;
}

export interface BriefDetails {
    address?: Address;
    budget?: number;
    communicateRate?: boolean;
    currencyCode: string;
    dailyFreelancerRate?: number;
    description?: string;
    freelancerAvailability?: FreelancerAvailability;
    numberOfFreelancers: number;
    projectDuration?: ProjectDuration;
    remote?: boolean;
    remoteFrequency?: number;
    startDate?: DateAsString;
    startDateFlexibility?: BriefStartDateFlexibility;
    startDateType?: BriefStartDateType;
    title?: string;
    workingStatus: BriefWorkingStatus;
}

export interface BriefManagerResource extends Resource {
    identityId: string;
    name: string;
    photo?: Photo;
}

export interface BriefProjectDetailsResource extends Resource {
    address: AddressView;
    budget?: number;
    communicateRate: boolean;
    currency?: BriefCurrency;
    dailyFreelancerRate?: number;
    description: string;
    descriptionEditable: boolean;
    experienceLevel: ExperienceLevel;
    freelancerAvailability?: FreelancerAvailability;
    freelancerBonusSkills: string[];
    freelancerMandatorySkills: string[];
    freelancerRequiredCategories: FreelancerCategoryResource[];
    languages: LanguageResource[];
    projectDuration: ProjectDuration;
    remote: boolean;
    remoteFrequency?: number;
    startDate: DateAsString;
    startDateFlexibility?: BriefStartDateFlexibility;
    startDateType: BriefStartDateType;
    type: string;
    workingStatus?: BriefWorkingStatus;
}

export interface BriefRequestAddress {
    administrativeAreaLevel1?: string;
    administrativeAreaLevel1Code?: string;
    administrativeAreaLevel2?: string;
    administrativeAreaLevel2Code?: string;
    administrativeAreaLevel3?: string;
    administrativeAreaLevel3Code?: string;
    administrativeAreaLevel4?: string;
    administrativeAreaLevel4Code?: string;
    city?: string;
    country?: string;
    countryCode?: string;
    formattedAddress?: string;
    loc: BriefRequestPoint;
    region?: string;
    street?: string;
    street2?: string;
    zipCode?: string;
}

export interface BriefRequestPoint {
    lat: number;
    lon: number;
}

export interface BriefResource extends Resource {
    archivedDate?: DateAsString;
    briefDetails?: BriefDetails;
    briefId: string;
    briefManager?: BriefManagerResource;
    company?: CompanyResource;
    companyId?: string;
    creationDate?: DateAsString;
    currentState: BriefStatus;
    draftState: AbstractDraftStateUnion;
    identityId?: string;
    launchedDate?: DateAsString;
    organization?: OrganizationResource;
    origin: BriefOrigin;
    profileDetails?: ProfileDetailsResource;
    submittable: boolean;
    type: BriefType;
}

export interface BriefStepsResource {
    nbApplicationAccepted: number;
    nbOnGoingConversations: number;
    nbReceivedQuotation: number;
}

export interface BriefStrategyEligibilityRejectionResource {
    reason: RejectReason;
}

export interface BriefStrategyRequest {
    clientIdentityId: string;
    freelancerBriefRequest: StrategyFreelancerBriefRequest;
    freelancerFunctionalScopesBriefRequest: StrategyFreelancerFunctionalScopesBriefRequest;
    freelancerIndustryExpertisesBriefRequest: StrategyFreelancerIndustryExpertisesBriefRequest;
    freelancerJobTitleBriefRequest: FreelancerJobTitleBriefRequest;
    freelancerSkillsBriefRequest: StrategyFreelancerSkillsBriefRequest;
    missionDescriptionBriefRequest: StrategyMissionDescriptionBriefRequest;
    whenConditionsBriefRequest: StrategyWhenConditionsBriefRequest;
    whereConditionsBriefRequest: StrategyWhereConditionsBriefRequest;
}

export interface BriefSubmissionRequest {
    identityId: string;
}

export interface BriefUserResource extends Resource {
    clientAdmin: boolean;
    clientIdentities: ClientIdentity[];
    companyId: string;
    firstName: string;
    identityId: string;
    maltAdmin: boolean;
    serviceLevelType: ServiceLevelType;
}

export interface CategoryPredictionResource extends Resource {
    category: FreelancerCategoryResource;
    probability: number;
}

export interface ClientIdentity {
    companyId: string;
    companyName: string;
    identityId: string;
    locatedCompanyBillingAddress?: AddressView;
    maltPlusAvailable: boolean;
    maltPlusBetaAvailable: boolean;
}

export interface CompanyFeesResource extends Resource {
    regularFees: number;
    strategyFees: number;
}

export interface CompanyResource {
    name?: string;
}

export interface DraftStateWrapper extends AbstractDraftState {
    draftState: DraftState;
    type: "DraftStateWrapper";
}

export interface DurationForm {
    fixed: boolean;
    unit: DurationUnit;
    value: number;
}

export interface FamilyResource extends Resource {
    categories: FreelancerCategoryResource[];
    familyId: string;
    label: string;
}

export interface FeesView {
    type: FeeType;
    value: number;
}

export interface FreelancerAddedRequest {
    clientIdentityId: string;
    clientProjectId: string;
    freelancerIdentityId: string;
}

export interface FreelancerBriefRequest {
    experienceLevel: BriefApiExperienceLevel;
    freelancerCategories: string[];
    fromSignup: boolean;
    jobTitle?: string;
    searchId?: string;
}

export interface FreelancerCategoryResource extends Resource {
    categoryId: string;
    familyId: string;
    label: string;
}

export interface FreelancerJobTitleBriefRequest {
    jobTitle?: string;
}

export interface FreelancerSelectionResource extends Resource {
    freelancersListId?: string;
    profiles: SelectedFreelancerResource[];
    shortlistId?: string;
}

export interface FreelancerSkillsBriefRequest {
    freelancerSkills: string[];
    languageCodes?: string[];
}

export interface FunctionalScopeItemResource {
    humanId: string;
    translation: string;
}

export interface FunctionalScopeResource {
    globalScope: FunctionalScopeItemResource;
    specificScopes: FunctionalScopeItemResource[];
}

export interface GivenBriefRequest {
    clientIdentityId: string;
    clientInsertionProfileIds: string[];
    expectedSourcingProcess: ExpectedSourcingProcess;
    freelancerBriefRequest: FreelancerBriefRequest;
    freelancerJobTitleBriefRequest: FreelancerJobTitleBriefRequest;
    freelancerSkillsBriefRequest: FreelancerSkillsBriefRequest;
    missionDescriptionBriefRequest: MissionDescriptionBriefRequest;
    whenConditionsBriefRequest: WhenConditionsBriefRequest;
    whereConditionsBriefRequest: WhereConditionsBriefRequest;
}

export interface IdentityAddressView {
    city?: string;
    country?: string;
    street1?: string;
    street2?: string;
    zipCode?: string;
}

export interface IdentitySelectorResource extends Resource {
    availableIdentities: IdentityView[];
    currentIdentity: IdentityView;
}

export interface IdentityView {
    address: IdentityAddressView;
    clientIdentityId: string;
    companyLegalName?: string;
    companyName: string;
}

export interface IndustryExpertiseItemResource {
    humanId: string;
    translation: string;
}

export interface IndustryExpertiseResource {
    businessIndustries: IndustryExpertiseItemResource[];
    businessSector: IndustryExpertiseItemResource;
}

export interface LanguageResource {
    code: string;
    label: string;
}

export interface MissionDescriptionBriefRequest {
    description: string;
    title?: string;
}

export interface NewEmailForm {
    email: string;
    password: string;
}

export interface OrganizationResource {
    name: string;
}

export interface Phone {
    number?: string;
}

export interface PhoneComponentSettingsResource {
    defaultCountryCode: string;
    lowerCasedSuggestedCountriesForPhoneNumbers: string[];
}

export interface PhoneRequest {
    number: string;
}

export interface Photo extends Serializable {
    absoluteUrl: string;
    baseUrl: string;
    cropped: boolean;
    deleteUrl: string;
    height: number;
    legend: string;
    name: string;
    originalExtension: string;
    originalMimeType: string;
    type: string;
    width: number;
}

export interface PhotoView {
    baseUrl: string;
    name: string;
}

export interface Point extends Serializable {
    lat: number;
    lon: number;
}

export interface PriceDetailsView {
    fees: FeesView;
    total: number;
}

export interface PriceView {
    currencyCode: string;
    details?: PriceDetailsView;
    ht: number;
}

export interface ProfileDetailsResource {
    experienceLevel?: BriefApiExperienceLevel;
    freelancerBonusSkills: string[];
    freelancerCategories: string[];
    freelancerCategoryLabels: string[];
    freelancerJobTitle?: string;
    freelancerMandatorySkills: string[];
    freelancerRequiredCategories: FreelancerCategoryResource[];
    freelancerSkills: string[];
    functionalScopes: StrategyFunctionalScopeResource[];
    industryExpertises: StrategyIndustryExpertiseResource[];
    languages: LanguageResource[];
}

export interface ProjectDuration {
    fixed: boolean;
    unit: ProjectDurationUnit;
    value: number;
}

export interface ProjectDurationRequest {
    fixed: boolean;
    unit: BriefRequestProjectDurationUnit;
    value: number;
}

export interface ProjectForm {
    /**
     * @deprecated
     */
    byShortlist: boolean;
    clientIdentityId?: string;
    correlationId?: string;
    description: string;
    /**
     * @deprecated
     */
    duration?: ProjectDurationEstimate;
    durationChoice?: DurationForm;
    files: ProjectFormStoredFile[];
    freelanceProfileIds: string[];
    freelancersListId?: string;
    jobTitle?: string;
    onSiteRequired: boolean;
    origin?: ShortListOrigin;
    profileViewId?: string;
    projectOrigin?: ProjectOrigin;
    shortlistId?: string;
    skills: string[];
    /**
     * @deprecated
     */
    start?: ProjectStartEstimate;
    startDate?: StartDateForm;
    title: string;
    workingDays?: WorkingDays;
    workingPlace?: WorkingPlaceForm;
}

export interface ProjectFormStoredFile {
    fileId: string;
    fileName: string;
}

export interface ProjectResource extends Resource {
    creationDate: DateAsString;
    details: BriefProjectDetailsResource;
    jobTitle: string;
    title: string;
}

export interface Resource {
    _links: ResourceLink[];
}

export interface ResourceLink {
    context: ResourceLink[];
    href: string;
    parameters?: TemplateParameter[];
    rel: string;
    type?: HttpMethod;
}

export interface SelectedFreelancerResource extends Resource {
    avgAnsweringTime?: string;
    firstName: string;
    fullName: string;
    headline?: string;
    lastName: string;
    malterLevels: MalterLevel[];
    photo?: PhotoView;
    preferredCategory?: string;
    price?: PriceView;
    profileId: string;
    ratings: number;
    recommendationsCount: number;
}

export interface Serializable {
}

export interface SkillsRequest {
    query: string;
}

export interface StartDateForm {
    flexibility: StartDateFlexibility;
    startDate?: DateAsString;
    type: StartDateType;
}

export interface StrategyBriefSubmissionRequest {
    identityId: string;
}

export interface StrategyDraftStateWrapper extends AbstractDraftState {
    strategyDraftState: StrategyDraftState;
    type: "StrategyDraftStateWrapper";
}

export interface StrategyFreelancerBriefRequest {
    dailyFreelancerRate: number;
    experienceLevel: BriefApiExperienceLevel;
    freelancerCategory: string;
    fromSignup: boolean;
    jobTitle: string;
    searchId?: string;
}

export interface StrategyFreelancerFunctionalScopesBriefRequest {
    functionalScopes: StrategyFunctionalScopeResource[];
}

export interface StrategyFreelancerIndustryExpertisesBriefRequest {
    industryExpertises: StrategyIndustryExpertiseResource[];
}

export interface StrategyFreelancerSkillsBriefRequest {
    freelancerSkills: string[];
    languageCodes: string[];
}

export interface StrategyFunctionalScopeResource {
    globalScopeHumanId: string;
    globalScopeTranslation?: string;
    specificScopeHumanId: string;
    specificScopeTranslation?: string;
}

export interface StrategyIndustryExpertiseResource {
    businessIndustryHumanId: string;
    businessIndustryTranslation?: string;
    businessSectorHumanId: string;
    businessSectorTranslation?: string;
}

export interface StrategyMissionDescriptionBriefRequest {
    description: string;
    title: string;
}

export interface StrategyWhenConditionsBriefRequest {
    budget?: number;
    freelancerAvailability: BriefRequestFreelancerAvailability;
    projectDuration: ProjectDurationRequest;
    startDate?: DateAsString;
    startDateFlexibility?: BriefRequestStartDateFlexibility;
    startDateType: BriefRequestStartDateType;
}

export interface StrategyWhereConditionsBriefRequest {
    address?: Address;
    remoteFrequency?: number;
    workingStatus: WorkingStatusRequest;
}

export interface SuggestSkillsRequest {
    category: string;
    job?: string;
}

export interface TemplateParameter {
    rel: string;
    value: string;
}

export interface TjmRecommendationRequest {
    category: string;
    experienceLevel: ExperienceLevel;
}

export interface WhenConditionsBriefRequest {
    budget?: number;
    communicateRate?: boolean;
    dailyFreelancerRate?: number;
    freelancerAvailability: BriefRequestFreelancerAvailability;
    projectDuration: ProjectDurationRequest;
    startDate?: DateAsString;
    startDateFlexibility?: BriefRequestStartDateFlexibility;
    startDateType: BriefRequestStartDateType;
}

export interface WhereConditionsBriefRequest {
    address?: BriefRequestAddress;
    remote?: boolean;
    remoteFrequency?: number;
    workingStatus?: WorkingStatusRequest;
}

export interface WorkingPlaceForm {
    address?: Address;
    remoteFrequency?: number;
    workingStatus: WorkingStatusForm;
}

export type AbstractDraftStateUnion = DraftStateWrapper | StrategyDraftStateWrapper;

export type DateAsString = string;

export enum BriefApiExperienceLevel {
    ENTRY = "ENTRY",
    INTERMEDIATE = "INTERMEDIATE",
    EXPERT = "EXPERT",
    EXPERT_PLUS = "EXPERT_PLUS",
}

export enum BriefCurrency {
    EUR = "EUR",
    GBP = "GBP",
    USD = "USD",
}

export enum BriefOrigin {
    SEARCH_PLUS = "SEARCH_PLUS",
    SIGNUP = "SIGNUP",
    SHAKE_LEGACY = "SHAKE_LEGACY",
    SHAKE = "SHAKE",
    PROJECT = "PROJECT",
    SEARCH_PROPOSAL = "SEARCH_PROPOSAL",
    JOB_DESCRIPTION_PDF = "JOB_DESCRIPTION_PDF",
    JOB_DESCRIPTION_TEXT = "JOB_DESCRIPTION_TEXT",
    INFERENCE_PROMPT = "INFERENCE_PROMPT",
}

export enum BriefRequestFreelancerAvailability {
    ONE_DAY_PER_WEEK = "ONE_DAY_PER_WEEK",
    TWO_DAYS_PER_WEEK = "TWO_DAYS_PER_WEEK",
    THREE_DAYS_PER_WEEK = "THREE_DAYS_PER_WEEK",
    FOUR_DAYS_PER_WEEK = "FOUR_DAYS_PER_WEEK",
    FULL_TIME = "FULL_TIME",
}

export enum BriefRequestProjectDurationUnit {
    DAYS = "DAYS",
    WEEKS = "WEEKS",
    MONTHS = "MONTHS",
}

export enum BriefRequestStartDateFlexibility {
    MORE_OR_LESS_2_DAYS = "MORE_OR_LESS_2_DAYS",
    MORE_OR_LESS_1_WEEK = "MORE_OR_LESS_1_WEEK",
    MORE_OR_LESS_1_MONTH = "MORE_OR_LESS_1_MONTH",
    NOT_FLEXIBLE = "NOT_FLEXIBLE",
}

export enum BriefRequestStartDateType {
    ASAP = "ASAP",
    CHOSEN_DATE = "CHOSEN_DATE",
    UNKNOWN = "UNKNOWN",
}

export enum BriefStartDateFlexibility {
    MORE_OR_LESS_2_DAYS = "MORE_OR_LESS_2_DAYS",
    MORE_OR_LESS_1_WEEK = "MORE_OR_LESS_1_WEEK",
    MORE_OR_LESS_1_MONTH = "MORE_OR_LESS_1_MONTH",
    NOT_FLEXIBLE = "NOT_FLEXIBLE",
}

export enum BriefStartDateType {
    ASAP = "ASAP",
    CHOSEN_DATE = "CHOSEN_DATE",
    UNKNOWN = "UNKNOWN",
}

export enum BriefStatus {
    DRAFT = "DRAFT",
    SUBMITTED = "SUBMITTED",
    ARCHIVED = "ARCHIVED",
    DELETED = "DELETED",
}

export enum BriefType {
    REGULAR = "REGULAR",
    STRATEGY = "STRATEGY",
}

export enum BriefWorkingStatus {
    REMOTELY = "REMOTELY",
    HYBRID = "HYBRID",
    ON_SITE = "ON_SITE",
}

export enum DraftState {
    INITIALIZED = "INITIALIZED",
    FREELANCER_SECTION_COMPLETED = "FREELANCER_SECTION_COMPLETED",
    FREELANCER_JOB_TITLE_SECTION_COMPLETED = "FREELANCER_JOB_TITLE_SECTION_COMPLETED",
    FREELANCER_SKILLS_SECTION_COMPLETED = "FREELANCER_SKILLS_SECTION_COMPLETED",
    WHEN_CONDITIONS_SECTION_COMPLETED = "WHEN_CONDITIONS_SECTION_COMPLETED",
    WHERE_CONDITIONS_SECTION_COMPLETED = "WHERE_CONDITIONS_SECTION_COMPLETED",
    MISSION_TITLE_SECTION_COMPLETED = "MISSION_TITLE_SECTION_COMPLETED",
    MISSION_DESCRIPTION_SECTION_COMPLETED = "MISSION_DESCRIPTION_SECTION_COMPLETED",
    NOT_DRAFT_ANYMORE = "NOT_DRAFT_ANYMORE",
}

export enum DurationUnit {
    DAYS = "DAYS",
    WEEKS = "WEEKS",
    MONTHS = "MONTHS",
}

export enum ExpectedSourcingProcess {
    WITH_ASSISTANCE = "WITH_ASSISTANCE",
    DELEGATED = "DELEGATED",
    PROVIDED_ONLY_SELECTION = "PROVIDED_ONLY_SELECTION",
}

export enum ExperienceLevel {
    ENTRY = "ENTRY",
    INTERMEDIATE = "INTERMEDIATE",
    EXPERT = "EXPERT",
    EXPERT_PLUS = "EXPERT_PLUS",
}

export enum FeeType {
    FLAT = "FLAT",
    SUCCESSIVE = "SUCCESSIVE",
    REPATRIATION = "REPATRIATION",
}

export enum FreelancerAvailability {
    ONE_DAY_PER_WEEK = "ONE_DAY_PER_WEEK",
    TWO_DAYS_PER_WEEK = "TWO_DAYS_PER_WEEK",
    THREE_DAYS_PER_WEEK = "THREE_DAYS_PER_WEEK",
    FOUR_DAYS_PER_WEEK = "FOUR_DAYS_PER_WEEK",
    FULL_TIME = "FULL_TIME",
}

export enum HttpMethod {
    GET = "GET",
    HEAD = "HEAD",
    POST = "POST",
    PUT = "PUT",
    PATCH = "PATCH",
    DELETE = "DELETE",
    OPTIONS = "OPTIONS",
    TRACE = "TRACE",
}

export enum MalterLevel {
    SUPER_MALTER_L1 = "SUPER_MALTER_L1",
    SUPER_MALTER_L2 = "SUPER_MALTER_L2",
    SUPER_MALTER_L3 = "SUPER_MALTER_L3",
}

export enum PhoneValidationStatus {
    NOT_APPLICABLE = "NOT_APPLICABLE",
    PHONE_NUMBER_OPTIONAL = "PHONE_NUMBER_OPTIONAL",
    PHONE_NUMBER_MISSING = "PHONE_NUMBER_MISSING",
    PHONE_NUMBER_NEED_VALIDATION = "PHONE_NUMBER_NEED_VALIDATION",
    PHONE_NUMBER_MISSING_AND_NEED_VALIDATION = "PHONE_NUMBER_MISSING_AND_NEED_VALIDATION",
    PHONE_NUMBER_OK = "PHONE_NUMBER_OK",
}

export enum ProjectDurationEstimate {
    LESS_THAN_1_WEEK = "LESS_THAN_1_WEEK",
    LESS_THAN_1_MONTH = "LESS_THAN_1_MONTH",
    BETWEEN_1_AND_3_MONTH = "BETWEEN_1_AND_3_MONTH",
    BETWEEN_3_AND_6_MONTH = "BETWEEN_3_AND_6_MONTH",
    MORE_THAN_6_MONTH = "MORE_THAN_6_MONTH",
    UNKNOWN = "UNKNOWN",
}

export enum ProjectDurationUnit {
    DAYS = "DAYS",
    WEEKS = "WEEKS",
    MONTHS = "MONTHS",
}

export enum ProjectOrigin {
    DEFAULT = "DEFAULT",
    SIGNUP = "SIGNUP",
    MISSION_RENEWAL = "MISSION_RENEWAL",
}

export enum ProjectStartEstimate {
    ASAP = "ASAP",
    NEXT_WEEK = "NEXT_WEEK",
    NEXT_MONTH = "NEXT_MONTH",
    UNKNOWN = "UNKNOWN",
}

export enum RejectReason {
    WRONG_JOB_CATEGORY = "WRONG_JOB_CATEGORY",
    EXPERIENCE_TOO_LOW = "EXPERIENCE_TOO_LOW",
    DAILY_RATE_TOO_LOW = "DAILY_RATE_TOO_LOW",
}

export enum ServiceLevelType {
    STANDARD = "STANDARD",
    ADVANCED = "ADVANCED",
    CORPORATE = "CORPORATE",
    ENTERPRISE = "ENTERPRISE",
}

export enum ShortListOrigin {
    POOL_OF_FREELANCERS = "POOL_OF_FREELANCERS",
    SHORTLIST = "SHORTLIST",
}

export enum StartDateFlexibility {
    NOT_FLEXIBLE = "NOT_FLEXIBLE",
    MORE_OR_LESS_2_DAYS = "MORE_OR_LESS_2_DAYS",
    MORE_OR_LESS_1_WEEK = "MORE_OR_LESS_1_WEEK",
    MORE_OR_LESS_1_MONTH = "MORE_OR_LESS_1_MONTH",
}

export enum StartDateType {
    ASAP = "ASAP",
    CHOSEN_DATE = "CHOSEN_DATE",
    UNKNOWN = "UNKNOWN",
}

export enum StrategyDraftState {
    INITIALIZED = "INITIALIZED",
    FREELANCER_SECTION_COMPLETED = "FREELANCER_SECTION_COMPLETED",
    FREELANCER_JOB_TITLE_SECTION_COMPLETED = "FREELANCER_JOB_TITLE_SECTION_COMPLETED",
    FREELANCER_FUNCTIONAL_SCOPES_SECTION_COMPLETED = "FREELANCER_FUNCTIONAL_SCOPES_SECTION_COMPLETED",
    FREELANCER_INDUSTRY_EXPERTISES_SECTION_COMPLETED = "FREELANCER_INDUSTRY_EXPERTISES_SECTION_COMPLETED",
    FREELANCER_SKILLS_SECTION_COMPLETED = "FREELANCER_SKILLS_SECTION_COMPLETED",
    WHEN_CONDITIONS_SECTION_COMPLETED = "WHEN_CONDITIONS_SECTION_COMPLETED",
    WHERE_CONDITIONS_SECTION_COMPLETED = "WHERE_CONDITIONS_SECTION_COMPLETED",
    MISSION_DESCRIPTION_SECTION_COMPLETED = "MISSION_DESCRIPTION_SECTION_COMPLETED",
    NOT_DRAFT_ANYMORE = "NOT_DRAFT_ANYMORE",
}

export enum WorkingDays {
    ONE_DAY = "ONE_DAY",
    TWO_DAYS = "TWO_DAYS",
    THREE_DAYS = "THREE_DAYS",
    FOUR_DAYS = "FOUR_DAYS",
    FIVE_DAYS = "FIVE_DAYS",
    UNKNOWN = "UNKNOWN",
}

export enum WorkingStatusForm {
    REMOTELY = "REMOTELY",
    HYBRID = "HYBRID",
    ON_SITE = "ON_SITE",
}

export enum WorkingStatusRequest {
    REMOTELY = "REMOTELY",
    ON_SITE = "ON_SITE",
    HYBRID = "HYBRID",
}
